/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_In_Transit_Requirements_DescriptionInputs */

const en_orders_in_transit_requirements_description = /** @type {(inputs: Orders_In_Transit_Requirements_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Driver Name, Tracking Number, and Driver Check-In for each selected order first.`)
};

const es_orders_in_transit_requirements_description = /** @type {(inputs: Orders_In_Transit_Requirements_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa Nombre del chofer, Numero de tracking y Hora de entrada para cada pedido seleccionado.`)
};

/**
* | output |
* | --- |
* | "Complete Driver Name, Tracking Number, and Driver Check-In for each selected order first." |
*
* @param {Orders_In_Transit_Requirements_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_in_transit_requirements_description = /** @type {((inputs?: Orders_In_Transit_Requirements_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_In_Transit_Requirements_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_in_transit_requirements_description(inputs)
	return es_orders_in_transit_requirements_description(inputs)
});